import React, { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Trust statistics — Track 1 priority #2.
 * Live counts from /api/public/landing-stats. Falls back to skeletons,
 * never shows zero or "—" counts that look broken.
 */
export default function TrustStats() {
  const [s, setS] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/public/landing-stats")
      .then(r => setS(r.data))
      .catch(() => setS({}))
      .finally(() => setLoaded(true));
  }, []);

  // Stat selection — only show stats with meaningful values.
  const items = [];
  if (s?.verified_suppliers > 0) items.push([s.verified_suppliers, "VERIFIED CANADIAN SUPPLIERS"]);
  if (s?.verified_buyers > 0) items.push([s.verified_buyers, "VERIFIED BUYERS"]);
  if (s?.rfqs_total > 0) items.push([s.rfqs_total, "RFQS HANDLED"]);
  if (s?.avg_award_days != null && s.avg_award_days > 0) items.push([`${s.avg_award_days}d`, "AVG TIME TO AWARD"]);

  // Always show 4 cells. Pad with strong static signals when DB is sparse.
  const fallback = [
    ["100%", "VERIFIED COMPANIES"],
    ["< 3 min", "TO CREATE AN RFQ"],
    ["RANKED", "BY WEIGHTED VALUE"],
    ["CAD", "NATIVE CURRENCY"],
  ];
  while (items.length < 4) items.push(fallback[items.length]);

  return (
    <section className="lp-trust" data-testid="landing-trust-stats">
      <div className="lp-container">
        <div className="lp-trust-grid">
          {!loaded
            ? Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="lp-trust-item">
                  <span className="skel skel-line lg" style={{ width: "60%" }}>0</span>
                  <span className="skel skel-line sm" style={{ width: "80%" }}>0</span>
                </div>
              ))
            : items.slice(0, 4).map(([k, v], i) => (
                <div key={i} className="lp-trust-item" data-testid={`landing-stat-${i}`}>
                  <div className="font-serif-display lp-trust-k">{k}</div>
                  <div className="font-mono lp-trust-v">{v}</div>
                </div>
              ))}
        </div>
      </div>
    </section>
  );
}
